import React, { FunctionComponent } from "react"

interface MonitorIconProps {
  color?: string
}

export const MonitorIcon: FunctionComponent<MonitorIconProps> = ({
  color = "yellow",
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.334 2.5H2.66732C1.93094 2.5 1.33398 3.09695 1.33398 3.83333V10.5C1.33398 11.2364 1.93094 11.8333 2.66732 11.8333H13.334C14.0704 11.8333 14.6673 11.2364 14.6673 10.5V3.83333C14.6673 3.09695 14.0704 2.5 13.334 2.5Z"
      fill={`var(--theme-${color})`}
      stroke={`var(--theme-${color})`}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33398 14.5H10.6673"
      stroke={`var(--theme-${color})`}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 11.8333V14.5"
      stroke={`var(--theme-${color})`}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
